import { render } from "./WhoWeAre.vue?vue&type=template&id=22dc85c2"
import script from "./WhoWeAre.vue?vue&type=script&lang=js"
export * from "./WhoWeAre.vue?vue&type=script&lang=js"

import "./WhoWeAre.vue?vue&type=style&index=0&id=22dc85c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__